export default "__VITE_ASSET__CrkDqb3C__"